import React from "react";
import styled from "styled-components";
import { Row, Col } from "reactstrap";
import { RebelButton } from "../../../../styles/rebel-experiences";
import { useParams } from "react-router-dom";
import RebelExperienceGuideInput from "./rebel-experience-guide-input";

const RebelExperiencesEdit = (props) => {
    let { experience } = useParams();
    if (experience === undefined) {
        window.history.replaceState(null, "", "/budget-app/rebel-experiences");
    }

    const backToGuideList = () => {
        window.location = "/budget-app/rebel-experiences";
    }

    return(
        <PageContainer>
            <Row style={{marginBottom: "30px"}}>
                <Col>

                </Col>
                {!props.client &&
                <Col style={{textAlign: "right"}}>
                    <RebelButton style={{marginTop: "30px", marginRight: "30px"}}
                                onClick={(x) => backToGuideList()}> Back to R.E.B.E.L Guide List</RebelButton>
                </Col>
                }
            </Row>
            <RebelExperienceGuideInput id={experience} client={props.client}/>
        </PageContainer>
    )
}

export default RebelExperiencesEdit;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;